import { Pressable, Text, View } from 'react-native';
import { useState } from 'react';
import { stls } from './styles';
import { SvgMinus } from './SvgMinus';
import { SvgPlus } from './SvgPlus';
import { TMergedLocalBikes } from '../mergeLocationBikes';

export type Tprops2 = {
  initValue: number;
  cbFunc: (count: number, mode: 'inc' | 'dec') => void;
  isDisabled: boolean;
  currItem: TMergedLocalBikes;
};

export const BtnCounter = (props: Tprops2) => {
  const { initValue, cbFunc, isDisabled, currItem } = props;
  const { allLocalIds } = currItem;

  const [sttCount, setCount] = useState(initValue);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  console.log({ selectedIds });

  const btnInc = () => {
    const newCount = sttCount + 1;
    const condStop = sttCount < allLocalIds.length;

    if (condStop) {
      setCount(newCount);
      cbFunc(newCount, 'inc');

      const available = allLocalIds.find(id => !selectedIds.includes(id));
      if (available) {
        setSelectedIds(prev => [...prev, available]);
      }
    }
  };

  const btnDec = () => {
    const newCount = sttCount - 1;
    const condStop = sttCount > 0;

    if (condStop) {
      setCount(newCount);
      cbFunc(newCount, 'dec');

      if (selectedIds.length > 0) {
        setSelectedIds(prev => prev.slice(0, -1));
      }
    }
  };
  return (
    <View style={stls.container}>
      <Pressable style={stls.btn1} onPress={btnDec} disabled={isDisabled}>
        <SvgMinus />
      </Pressable>

      <Text style={{ marginHorizontal: 6 }}>{sttCount}</Text>

      <Pressable style={stls.btn1} onPress={btnInc} disabled={isDisabled}>
        <SvgPlus />
      </Pressable>
    </View>
  );
};
